const styles = ({ spacing }) => ({
  '& div': {
    minWidth: '50%',
  },
  display: 'flex',
  flexWrap: 'wrap',

  paddingTop: spacing.unit,
});

export default styles;
